import React, { useState, useEffect } from "react";
import TopSection from "./TopSection";
import EnvelopeDocuments from "./EnvelopeDocuments";
import ActivitySidebar from "./ActivitySidebar";
import { getDocuments } from "../../api";

const Dashboard = ({
  onAction,
  dark,
  toggleTheme,
  envelope,
  company,
  onSwitchCompany,
  prevCompany,
  onGoToPrevious,
  companies,
  user,
  onLogout,
}) => {
  const [documents, setDocuments] = useState([]);
  const [refreshTick, setRefreshTick] = useState(0);

  const loadDocs = () =>
    getDocuments(company.key)
      .then((d) => {
        setDocuments(d);
        setRefreshTick((t) => t + 1);
      })
      .catch(() => onAction("Failed to load documents"));

  useEffect(() => {
    loadDocs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company]);

  return (
    <>
      <TopSection
        onAction={onAction}
        dark={dark}
        toggleTheme={toggleTheme}
        envelope={envelope}
        documents={documents}
        company={company}
        onSwitchCompany={onSwitchCompany}
        prevCompany={prevCompany}
        onGoToPrevious={onGoToPrevious}
        companies={companies}
        user={user}
        onLogout={onLogout}
      />
      <div className="mt-6 grid grid-cols-1 gap-6 px-6 md:px-10 lg:grid-cols-[1.7fr_1fr]">
        <div className="min-h-[520px]">
          <EnvelopeDocuments
            dark={dark}
            onAction={onAction}
            documents={documents}
            reloadDocs={loadDocs}
            company={company}
            user={user}
          />
        </div>
        <div className="min-h-[520px]">
          <ActivitySidebar onAction={onAction} dark={dark} company={company} refreshTick={refreshTick} />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
